import { Component, OnInit } from '@angular/core';
import {TopicService } from '../topic.service';
import { GeneralComponent } from '../../General/g.component';

@Component({
  selector: 'app-exercises',
  templateUrl: './exercises.component.html',
  styleUrls: ['../../General/tiles.css', './exercises.component.css']
})
export class ExercisesComponent extends GeneralComponent {

  allExercises: any[] = null;
  page = 0;
  pageCount = 1;
  showTip = true;

  pageSize = 15;

  constructor(public topicService: TopicService) {
    super(topicService);
    this.allExercises = topicService.getAllExercisesInfo();
    this.pageCount = Math.max(Math.ceil(this.allExercises.length / this.pageSize), 1);
  }

  /** compute the correct exercises for the given page */
  getItems(page: number) {
    const start = (this.page) * this.pageSize;
    const end = (this.page + 1) * this.pageSize;
    if (end <= this.allExercises.length) {
      return this.allExercises.slice(start, end);
    } else {
      const exercisePart = this.allExercises.slice(start, this.allExercises.length);
      return exercisePart;
    }
  }

  /** has an helper video for this exercise */
  hasHelperVideo(helperVideo) {
    return (helperVideo !== '' && helperVideo !== undefined);
  }
}
